import { decode } from "@clockwise/web-commons/src/util/eventKeyEncoding";
import { Match } from "found";

export const getActiveEventKeyFromRoute = (match: Match) => {
  const { encodedExternalEventId } = match.params;

  if (!encodedExternalEventId) return null;

  const decoded = decode(encodedExternalEventId);

  if (!decoded) return null;

  return decoded;
};
